import React, { Component } from "react";
import PropTypes from "prop-types";
import Button from "@p1s/p1s-common-react/Button";
import { connect } from "react-redux";
import * as actions from "../../actions/EmailAuthenticationActions";
import TextInput from "../../controls/TextInput";
import { requiredValue } from "../validation/AccountValidations";
import ServerError from "../common/ServerError";
import { isEnterPressed } from "newApp/utilities/EventsHelper";

export class CheckPasswordOnLinkToVirtualUser extends Component {
    constructor (props) {
        super(props);
        this.state = {
            password: undefined,
            validationError: undefined
        };

        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onEnter = this.onEnter.bind(this);
        this.onComplete = this.onComplete.bind(this);
    }

    onPasswordChange (e) {
        if (e && e.target)
            this.setState({ password: e.target.value });
    }

    onEnter (e) {
        if (isEnterPressed(e))
            this.onComplete();
    }

    onComplete () {
        const validationResult = requiredValue(this.state.password);
        if (validationResult.isValid) {
            this.setState({ validationError: undefined });
            this.props.linkToVirtualUser(this.props.email, this.state.password);
        }
        else
            this.setState({ validationError: validationResult.error });
    }

    render () {
        const serverError = this.props.serverError;
        const validationError = this.state.validationError;

        const hasServerError = serverError != null && serverError.length > 0;
        const hasValidationError = validationError != null && validationError.length > 0;

        return (
            <div className="loginEmail-popup" name="enterPassword">
                <div className="signIn-form-title">Link Accounts</div>
                <div className="signIn-form-subtitle">
                    <span className="email email-link" onClick={this.props.backToEmailForm}>
                        <i className="material-icons">arrow_back</i>
                        <span>{this.props.email}</span>
                    </span>
                </div>

                <div>
                    This account has already been upgraded. To link additional user credentials to this email account, enter the password for {this.props.email}.
                </div>

                <div className="input-row">
                    <TextInput placeholder="Password" name="password"
                        isPassword={true}
                        onChange={this.onPasswordChange}
                        onKeyUp={this.onEnter}
                        inputClassName="picker-hollow"
                        error={validationError}/>
                </div>
                <div className="button-container">
                    <Button id="btnLinkAccounts" className="btn btn-primary-action pull-right" onClick={this.onComplete}>Link Accounts</Button>
                </div>

                <ServerError
                    errorSummary={"Login Failed"}
                    serverError={serverError}
                    isVisible= {hasServerError && !hasValidationError} />
            </div>);
    }
}

CheckPasswordOnLinkToVirtualUser.propTypes = {
    email: PropTypes.string,
    serverError: PropTypes.string,
    backToEmailForm: PropTypes.func,
    linkToVirtualUser: PropTypes.func
};

const mapStateToProps = state => ({
    serverError: state.emailLoginState.error
});

const mapDispatchToProps = (dispatch) => {
    return ({
        backToEmailForm: () => dispatch(actions.goToTheFirstLinkingEmailStep()),
        linkToVirtualUser: (email, password) => dispatch(actions.linkToVirtualUser(email, password))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckPasswordOnLinkToVirtualUser);
